import { Partner } from '@provision/entity-types';

export enum CompanyInfoField {
  Address = 'address',
  City = 'city',
  State = 'state',
  Zip = 'zip',
  OfficePhone = 'mainOfficePhone',
  TimeZone = 'timeZone',
  BillingEmail = 'billingEmail',
  BillingEmail2 = 'billingEmail2',
  WebsiteUrl = 'websiteUrl',
}

export interface CompanyInfoFormValues {
  [CompanyInfoField.Address]: string;
  [CompanyInfoField.City]: string;
  [CompanyInfoField.State]: string;
  [CompanyInfoField.Zip]: string;
  [CompanyInfoField.OfficePhone]: string;
  [CompanyInfoField.TimeZone]: string;
  [CompanyInfoField.BillingEmail]: string;
  [CompanyInfoField.BillingEmail2]: string;
  [CompanyInfoField.WebsiteUrl]: string;
}

export type CompanyInfoPartner = Pick<
  Partner,
  | 'partnerId'
  | 'businessName'
  | 'zendeskDomain'
  | 'supportEmail'
  | 'supportPhone'
  | 'membershipEmail'
  | 'membershipSalesCalendlyLink'
  | 'address'
  | 'city'
  | 'state'
  | 'zip'
  | 'timeZone'
  | 'billingEmail'
  | 'billingEmail2'
  | 'websiteUrl'
> & {
  mainOfficePhone: string | null;
};

export const DEFAULT_FORM_VALUES: CompanyInfoFormValues = {
  [CompanyInfoField.Address]: '',
  [CompanyInfoField.City]: '',
  [CompanyInfoField.State]: '',
  [CompanyInfoField.Zip]: '',
  [CompanyInfoField.OfficePhone]: '',
  [CompanyInfoField.TimeZone]: '',
  [CompanyInfoField.BillingEmail]: '',
  [CompanyInfoField.BillingEmail2]: '',
  [CompanyInfoField.WebsiteUrl]: '',
};

export const getFormValuesFromPartner = (
  partner: CompanyInfoPartner | null,
): CompanyInfoFormValues => ({
  [CompanyInfoField.Address]: partner?.address || '',
  [CompanyInfoField.City]: partner?.city || '',
  [CompanyInfoField.State]: partner?.state || '',
  [CompanyInfoField.Zip]: partner?.zip || '',
  [CompanyInfoField.OfficePhone]: partner?.mainOfficePhone || '',
  [CompanyInfoField.TimeZone]: partner?.timeZone || '',
  [CompanyInfoField.BillingEmail]: partner?.billingEmail || '',
  [CompanyInfoField.BillingEmail2]: partner?.billingEmail2 || '',
  [CompanyInfoField.WebsiteUrl]: partner?.websiteUrl || '',
});
